module.exports = new __parcel__URL__("card_eagle.addc6692.png").toString();